export default "__VITE_ASSET__abd59a1d__"